import { Search } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import { useState } from "react";

export default function SearchBar({
  placeholder = "Search",
  onSearch,
  debounceDelay = 400,
  size = "small",
  className = "custom-input",
  sx = {},
  disabled = false,
  showSearchIcon = true,
  ...textFieldProps
}) {
  const [searchValue, setSearchValue] = useState("");
  const [timerId, setTimerId] = useState(null);

  const debouncedSearch = (value) => {
    if (timerId) {
      clearTimeout(timerId);
    }

    const newTimerId = setTimeout(() => {
      if (onSearch) {
        onSearch(value);
      }
    }, debounceDelay);

    setTimerId(newTimerId);
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    setSearchValue(newValue);
    debouncedSearch(newValue);
  };

  return (
    <TextField
      id="search-input"
      size={size}
      placeholder={placeholder}
      type="search"
      className={className}
      sx={sx}
      value={searchValue}
      onChange={handleChange}
      disabled={disabled}
      InputProps={{
        startAdornment: showSearchIcon && (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      {...textFieldProps}
    />
  );
}
